<template>
  <div class="item-timer">
    <svg class="item-timer__svg" :viewBox="`0 0 ${size} ${size}`" xmlns="http://www.w3.org/2000/svg">
      <g class="item-timer__circle">
        <path
          class="item-timer__path-elapsed"
          :transform="`translate(${size/2},${size/2})`"
          :d="countdownArc().elapsed"
        ></path>
        <path
          class="item-timer__path-remaining"
          :class="`fill-${colorVariant}`"
          :transform="`translate(${size/2},${size/2})`"
          :d="countdownArc().remaining"
        ></path>

      </g>
    </svg>
    <span class="item-timer__label" :class="`color-${colorVariant}`">
      {{ formattedTimeLeft }}
    </span>
  </div>
</template>

<script>
import colorVariantMixin from '@/components/mixins/colorVariantMixin'
import { arc } from 'd3'
export default {
  name: 'timer',
  mixins: [
    colorVariantMixin
  ],
  props: {
    // initial time limit
    timeLimit: {
      type: Number,
      default: 10000
    },
    // currently left
    currentTimeLeft: {
      type: Number,
      default: 10000
    },
    paused: {
      type: Boolean
    } 
  },
  data() {
    return {
      timePassed: 0,
      timerInterval: null,
      size: 190
    };
  },
  computed: {
    timeLeft() {
      return Math.round((this.timeLimit - this.timePassed) / 1000);
    },
    formattedTimeLeft() {
      const timeLeft = this.timeLeft;
      let seconds = timeLeft % 60;

      return seconds;
    },
  },

  watch: {
    timeLeft(newValue) {
      if (newValue === 0) {
        this.onTimesUp();
      }
    },
    paused() {
      if(this.paused) {
        this.pause()
      } else {
        this.restart()
      }
    }
  },

  mounted() {
    if(this.currentTimeLeft === 0) {
      this.timePassed = this.timeLimit
      this.onTimesUp()
    } else {
      this.timePassed = this.timeLimit - this.currentTimeLeft
      this.startTimer();
    }
  },

  methods: {
    onTimesUp() {
      clearInterval(this.timerInterval);
      this.$emit('timesUp')
    },
    startTimer() {
      this.timerInterval = setInterval(() => this.timePassed += 1000, 1000);
    },
    pause() {
      clearInterval(this.timerInterval);
    },
    restart() {
      this.startTimer()
    },
    countdownArc() {
      const remainingAngle = - this.timePassed/this.timeLimit * 2 * Math.PI
      const baseArc = arc().innerRadius(75).outerRadius(90)
      
      return {
        remaining: baseArc.startAngle(remainingAngle).endAngle(-2 * Math.PI)(),
        elapsed: baseArc.startAngle(0).endAngle(-2 * Math.PI).innerRadius(0).outerRadius(90)()
      }
    },
  },
  destroyed() {
    clearInterval(this.timerInterval)
  }
};
</script>

<style scoped lang="scss">
.item-timer {
  position: relative;
  width: 95px;
  height: 95px;

  @media screen and (max-width: 575px) {
    width: 70px;
    height: 70px;
  }

  &__svg {
    transform: scaleX(-1);
  }

  &__circle {
    fill: #EEE;
    stroke: none;
  }


  &__path-remaining {
    stroke-linecap: round;

  }

  &__path-elapsed {
    opacity: 0.9;
    fill: $base_grey-1;
  }

  &__label {
    position: absolute;
    width: 95px;
    height: 95px;
    font-size: 2.25em;
    @media screen and (max-width: 575px) {
      width: 70px;
      height: 70px;
      font-size: 1.75em;
    }
    top: 0;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
